import React from 'react';
import { ExternalLink } from 'lucide-react';
import type { SearchCaseLawWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: SearchCaseLawWidgetData;
}

export const SearchCaseLawWidget: React.FC<Props> = ({ data }) => {
  if (data.results.length === 0) return null;

  return (
    <div className="mt-1.5 space-y-1">
      <div className="flex items-center justify-between">
        <p className="text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500 font-medium">
          {data.results.length} judgment{data.results.length !== 1 ? 's' : ''}
        </p>
        {data.searchUrl && (
          <a
            href={data.searchUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[10px] text-amber-500 dark:text-amber-400 hover:underline flex items-center gap-0.5"
          >
            National Archives <ExternalLink className="h-2.5 w-2.5" />
          </a>
        )}
      </div>
      <div className="space-y-1">
        {data.results.map((r, i) => (
          <a
            key={i}
            href={r.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[11px] bg-amber-50/70 dark:bg-amber-900/10 rounded px-2 py-1.5 group hover:bg-amber-100/70 dark:hover:bg-amber-900/20 transition-colors"
          >
            {r.neutralCitation && (
              <span className="text-[10px] font-mono text-amber-600 dark:text-amber-400 whitespace-nowrap">
                {r.neutralCitation}
              </span>
            )}
            <span className="font-medium text-amber-700 dark:text-amber-300 truncate flex-1 min-w-0">
              {r.title}
            </span>
            {r.court && (
              <span className="text-[9px] text-amber-500 dark:text-amber-500 whitespace-nowrap">
                {r.court}
              </span>
            )}
            {r.date && (
              <span className="text-[9px] text-amber-400 dark:text-amber-600 whitespace-nowrap">
                {r.date.substring(0, 10)}
              </span>
            )}
            <ExternalLink className="h-2.5 w-2.5 text-amber-400 dark:text-amber-500 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
          </a>
        ))}
      </div>
    </div>
  );
};
